import { render, staticRenderFns } from "./ProgramDialog.vue?vue&type=template&id=5bd5b632&scoped=true&"
import script from "./ProgramDialog.vue?vue&type=script&lang=ts&"
export * from "./ProgramDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramDialog.vue?vue&type=style&index=0&id=5bd5b632&lang=sass&scoped=true&"
import style1 from "./ProgramDialog.vue?vue&type=style&index=1&lang=sass&"
import style2 from "./ProgramDialog.vue?vue&type=style&index=2&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5b632",
  null
  
)

export default component.exports